// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.10-13142(758076d40f)-C12/08/2026-15:53:24-B12/08/2026-16:09:24' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.10-13142(758076d40f)-C12/08/2026-15:53:24-B12/08/2026-16:09:24",
  branch: "production",
  latestTag: "8.0.10",
  revCount: "13142",
  shortHash: "758076d40f",
  longHash: "758076d40f3125e02af017a80de135bb262c444e",
  dateCommit: "12/08/2026-15:53:24",
  dateBuild: "12/08/2026-16:09:24",
  buildType: "Ansible",
  } ;
